import { type Article } from '~/types/article';
import { type PublicationContext } from '~/types';
import BodyProcessor from '~/helper/article/processors/bodyProcessor';

export function useArticleProcessor (article: Article, publicationContext: PublicationContext) {
  function injectInlineItems () {
    // need to use state, we can not use async composable here
    const adConfig = useState('adConfig', () => null);
    const articleAdConfig = adConfig.value ? adConfig.value.article : {};

    const bodyProcessor = new BodyProcessor(publicationContext, articleAdConfig);
    bodyProcessor.process(article);
  }

  return {
    injectInlineItems
  };
}
